import { css } from '@emotion/css'

const styles = css`
  z-index: 10;
  position: absolute;
  left: 0;
  top: 100%;
  margin-top: 2px;
  overflow: hidden;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12),
    0px 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  background-color: #ffffff;
  width: 100%;
  padding: 8px 0;

  .optionsWr {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow: auto;
    max-height: 200px;
  }

  .option {
    background-color: transparent;
    border: none;
    outline: none;
    transition: background-color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    min-height: 40px;
    text-align: left;
    padding: 5px 10px;
  }

  .optionActive {
    background-color: #e0e3e6;
  }
`

export default styles
